import React, { useEffect } from 'react';
import { Typography, Card, Spin, Button, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getRecentReports } from '.';
import { Sizes, LOADING, loadingSelector, ReducerNames } from 'common';
import { AppState } from 'store';
import { DAYS_COUNT } from './RecentReports.constants';
import { recentReportsSelector } from './RecentReports.selectors';
import RecentReportsTable from './RecentReportsTable';
import { Redirect } from 'react-router-dom';
import { useAccount, useMsal } from '@azure/msal-react';
import { getAccessToken } from 'common/helpers';
import { InteractionStatus } from '@azure/msal-browser';
const { Title } = Typography;

const RecentReports: React.FC = () => {
  const dispatch = useDispatch();
  const { loading, recentReports } = useSelector((state: AppState) => ({
    loading: loadingSelector(ReducerNames.RECENT_REPORTS)(state),
    recentReports: recentReportsSelector(state),
  }));
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(getRecentReports(DAYS_COUNT, response.accessToken));
      });
    }
  }, [dispatch, instance, account, inProgress]);

  const login = useSelector((state: AppState) => state.login);

  const handleOnClick = () => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(getRecentReports(DAYS_COUNT, response.accessToken));
      });
    }
  };

  if (login.user?.licenseflag == 'False') {
    return <Redirect to={`/pages/license`} />;
  }
  return (
    <Spin spinning={loading} size={Sizes.LARGE} tip={LOADING}>
      <Card>
        <Row type="flex" justify="space-between">
          <Title level={3}>Recent Reports ({DAYS_COUNT} days) </Title>
          <Button
            type="primary"
            size="small"
            onClick={handleOnClick}
            icon="reload"
          >
            Refresh
          </Button>
        </Row>
        <RecentReportsTable {...{ recentReports }} />
      </Card>
    </Spin>
  );
};

export default RecentReports;
